import {Avatar, CardMedia, Grid} from '@mui/material';

import FallbackLight from '../../../../../assets/job_postings/Fallback-banner-light.png';

interface Props {
  bannerUrl?: string;
  avatarUrl?: string;
}
export const CompanyBanner = ({bannerUrl, avatarUrl}: Props) => (
  <Grid>
    <Grid height='160px'>
      <CardMedia
        component='img'
        height='100%'
        image={bannerUrl || FallbackLight}
        alt='company_banner'
        sx={{
          objectFit: 'cover',
          objectPosition: 'center',
        }}
      />
    </Grid>
    <Avatar
      src={avatarUrl}
      variant='square'
      sx={{width: '150px', height: '150px', marginLeft: '32px', top: '-62px'}}
      alt='company_logo'
    />
  </Grid>
);
